<template>
  <div class="text-center">
    <v-dialog v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-btn class="button-new-group" color="primary" v-on="on" :icon="icon">
          <v-icon v-if="spaceObjectGroup != null">edit</v-icon>
          <span v-else>New space object group</span>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="cardheader">
          <span v-if="spaceObjectGroup != null" class="black--text text-h5">
            Update the space object group : {{ spaceObjectGroup.name }}</span
          >
          <span v-else class="black--text text-h5">Create a new group</span>
          <v-spacer></v-spacer>
          <v-btn icon light class="m-0" v-on:click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-text-field label="Name" v-model="localName"></v-text-field>
              </v-col>
              <v-col cols="12">
                <NoradTextField
                  v-model="localIds"
                  label="NORAD IDs of this group members"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-data-table
                :headers="headerTableSatellitesInformations"
                :items="listSatellitesInformations"
                :height="400"
                style="width: 100%"
                dense
              ></v-data-table>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="saveAndClose()"
            :disabled="!inputsValid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import defense from '../../mixins/defense.js'
import NoradTextField from './NoradTextField'
import spaceObjectGroupUtils from '../../mixins/spaceObjectGroupUtils.js'
export default {
  name: 'ScreeningCatalogueAnalysisGroupDialogue',
  mixins: [defense, spaceObjectGroupUtils],
  props: {
    spaceObjectGroup: {
      type: Object,
      default: null
    }
  },

  components: { NoradTextField },
  data() {
    return {
      localName: null,
      localIds: null,
      localIdsArr: [],
      dialog: false,
      icon: false,
      listSatellitesInformations: [],
      headerTableSatellitesInformations: [],
      context: 'SpaceObjectCatalogueItem'
    }
  },
  watch: {
    localIds() {
      if (
        this.localIds !== null &&
        JSON.stringify(this.localIds) !== JSON.stringify(this.localIdsArr)
      ) {
        this.updateListSatelliteFromCatalogue()
        this.localIdsArr = this.localIds
      }
    }
  },
  computed: {
    justIcon() {
      if (this.spaceObjectGroup != null) {
        return true
      } else {
        return false
      }
    },
    inputsValid() {
      if (this.localName != null && this.localIds != null) {
        return true
      } else {
        return false
      }
    }
  },
  async mounted() {
    this.init()
    this.getHeaderListSatelliteFromCatalogue()
  },
  methods: {
    init() {
      if (this.spaceObjectGroup != null) {
        this.icon = true
        this.localName = this.spaceObjectGroup.name
        this.localIds = this.spaceObjectGroup.spaceObjectIdentifiers
      }
    },

    async saveAndClose() {
      if (this.spaceObjectGroup) {
        await this.updateSpaceObjectGroup({
          name: this.localName,
          spaceObjectIdentifiers: this.localIds,
          id: this.spaceObjectGroup.id
        })
      } else {
        await this.createSpaceObjectGroup({
          name: this.localName,
          spaceObjectIdentifiers: this.localIds
        })
        this.localIds = null
        this.localName = null
      }

      this.$emit('update-space-object-group')
      this.close()
    },

    close() {
      this.dialog = false
    },

    async updateListSatelliteFromCatalogue() {
      this.listSatellitesInformations = []

      if (this.localIds != null) {
        let copyLocalIds = this.localIds
        this.listSatellitesInformations =
          await this.getDataSatellitesByNoradIdList(copyLocalIds)

        let listSatelliteInformationsBeforeConversion =
          await this.getDataSatellitesByNoradIdList(copyLocalIds)
        this.listSatellitesInformations =
          listSatelliteInformationsBeforeConversion.map(
            (satelliteInformations) => {
              for (const property in satelliteInformations) {
                if (
                  satelliteInformations[property] === '' ||
                  satelliteInformations[property] === 'NaN'
                ) {
                  satelliteInformations[property] = 'N/A'
                } else {
                  satelliteInformations[property] =
                    this.getDisplayValueFromPathFieldDescription(
                      satelliteInformations[property],
                      [property],
                      this.context
                    )
                }
              }
              return satelliteInformations
            }
          )
      }
    },

    async getHeaderListSatelliteFromCatalogue() {
      this.headerTableSatellitesInformations = this.getHeadertableCatalogue(
        await this.getDataSatelliteByNoradId('37150')
      ) //i took a satellite with all the information to get the header
    },

    getHeadertableCatalogue(satelliteInformations) {
      return Object.keys(satelliteInformations).map((cle) => {
        return {
          text: this.getLabelWithUnitFromPathFieldDescription(
            [cle],
            this.context
          ),
          value: cle
        }
      })
    }
  }
}
</script>
<style>
.cardheader {
  background: #3be287;
}
.button-new-group {
  margin-left: 5px;
  margin-right: 5px;
}
</style>
